module.exports = __webpack_public_path__ + "static/media/30-4.704dd1a4.mp3";